import { axios } from '@/lib/axios';

export const getFaqList = ( order: string ) => {
  return axios.get('/api/v1/data-faqs/get-faq-list', {
    params: { order }
  })
}

export const getFaqTop10 = () => {
  return axios.get('/api/v1/data-faqs/get-faq-top10')
}

export const getFaq = ( id: number ) => {
  return axios.get('/api/v1/data-faqs/get-faq', {
    params: { id }
  })
}

export const getFaqSearchConditionList=()=>{
  return axios.get('/api/v1/data-faqs/get-faq-search-condition-list')
}